import attributes from '../constants/attributes';

const normalizeNoWrapTraitValue = (value) => (value ? 'no-wrap' : 'wrap');

const traitValueNormalizers = {
  [attributes.NO_WRAP]: normalizeNoWrapTraitValue,
};

export default traitValueNormalizers;
